module.exports = __webpack_public_path__ + "img/arrowLeft.7592125b.svg";